import React, { useState } from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { BookDemoForm } from "@/components/BookDemoForm";
import ctaImage from "@/assets/cta-image-new.webp";

export function CTASection() {
  const [showDemoForm, setShowDemoForm] = useState(false);

  return (
    <>
      <section
        className="w-full overflow-hidden"
        style={{ background: "linear-gradient(to bottom, hsl(var(--sailcloth) / 1), hsl(var(--horizon) / 1))" }}
        aria-labelledby="cta-heading"
      >
        <div className="w-full max-w-[1440px] mx-auto px-4 sm:px-8 md:px-12 lg:px-20 3xl:px-28 4xl:px-32 pt-20">
          {/* Content */}
          <motion.div
            className="flex flex-col items-center text-center max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <span className="text-caption text-beacon uppercase mb-4">Learn More</span>
            <h2 id="cta-heading" className="text-h1 text-foreground mb-6">
              Ready to Make Technology Work for the Seniors Who Need It Most?
            </h2>
            <p className="text-body-lg text-foreground mb-8">
              Let's explore how GrandPad can help your organization reduce isolation, strengthen communication, and drive
              measurable improvements in outcomes for older adults.
            </p>
            <Button 
              variant="primary" 
              size="lg" 
              className="!text-sailcloth text-button px-8 py-6 mb-8 my-6"
              onClick={() => setShowDemoForm(true)}
            >
              Book a Demo
            </Button>
            <p className="text-body text-foreground">
              or call{" "}
              <a href="tel:8339771250" className="text-beacon hover:underline font-normal">
                (833) 977-1250
              </a>
            </p>
          </motion.div>

          {/* Image */}
          <motion.div
            className="flex justify-center mt-12"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.7, ease: "easeOut", delay: 0.2 }}
          >
            <img
              src={ctaImage}
              alt="Caregiver helping senior use GrandPad tablet"
              className="w-full max-w-4xl max-lg:max-w-none h-auto object-contain"
              width={1920}
              height={1070}
              loading="lazy"
              decoding="async"
            />
          </motion.div>
        </div>
      </section>

      <BookDemoForm 
        open={showDemoForm} 
        onOpenChange={setShowDemoForm}
      />
    </>
  );
}
